import gql from "graphql-tag";
import { merge } from "lodash";

import client from "../../apollo";
import { LS_USER_CACHE, REFRESH_ERROR_DELAY, REFRESH_GUEST_DELAY, REFRESH_USER_DELAY } from "../../config";

import GetMeQuery from './GetMeQuery.graphql';

// Global request loading
let loading = false;

const shouldRefreshUser = (previousData) => {
    // Already refreshing
    if (loading) {
        return false;
    }

    // First loading, there is no data in cache
    if (!previousData || !previousData?.__lastUpdate) {
        return true;
    }

    // Refresh delay
    const delay = (() => {
        if (previousData?.data && !previousData?.data?.me && previousData?.data?.errors?.length === 0) {
            return REFRESH_GUEST_DELAY;
        }
        if (!previousData?.data || previousData?.data?.errors?.length > 0) {
            return REFRESH_ERROR_DELAY;
        }
        return REFRESH_USER_DELAY;
    })();

    // Compare time
    return previousData.__lastUpdate + delay * 1000 < new Date().getTime();
};

export const getCurrentUserFromCache = () => (localStorage.getItem(LS_USER_CACHE) ? JSON.parse(localStorage.getItem(LS_USER_CACHE))?.data : null) || null;

export const refreshCurrentUser = async (forceRefresh = false) => {
    const previousData = JSON.parse(localStorage.getItem(LS_USER_CACHE) || '{}') || {};
    if (forceRefresh || shouldRefreshUser(previousData)) {
        localStorage.setItem(LS_USER_CACHE, JSON.stringify({ ...previousData, __lastUpdate: new Date().getTime() }));
        loading = true;
        const raw = await client.query({ query: gql(GetMeQuery), fetchPolicy: 'network-only' }).catch(() => null);
        if (raw && !raw?.data?.errors) {
            localStorage.setItem(LS_USER_CACHE, JSON.stringify({ ...raw, __lastUpdate: new Date().getTime() }));
        }
        loading = false;
    }
    return getCurrentUserFromCache();
};

export const patchCurrentUser = (user) => {
    const previousData = JSON.parse(localStorage.getItem(LS_USER_CACHE) || '{}') || {};
    localStorage.setItem(LS_USER_CACHE, JSON.stringify(merge(previousData, { data: { me: user } })));
    return getCurrentUserFromCache();
}